import heroCow from "@/assets/hero-cow.jpg";
import heroDog from "@/assets/hero-dog.jpg";
import heroBird from "@/assets/hero-bird.jpg";
import causeFodder from "@/assets/cause-fodder.jpg";
import causeSurgery from "@/assets/cause-surgery.jpg";
import causeAmbulance from "@/assets/cause-ambulance.jpg";
import causeWater from "@/assets/cause-water.jpg";
import causeBird from "@/assets/cause-bird.jpg";
import causeStray from "@/assets/cause-stray.jpg";
import eventRation from "@/assets/event-ration-drive.jpg";
import eventMedical from "@/assets/event-medical-camp.jpg";
import eventTree from "@/assets/event-tree-plantation.jpg";
import eventKitchen from "@/assets/event-community-kitchen.jpg";
import manavtaLogo from "@/assets/manavta-logo.png";
import pritamImg from "@/assets/pritam-singhvi.png";
import sandeepImg from "@/assets/sandeep-singhvi.png";
import drJigarImg from "@/assets/dr-jigar-shah.jpg";
import coolsjesImg from "@/assets/coolsjes-singhvi.png";
import riddhiImg from "@/assets/riddhi-singhvi.png";
import nariShakti from "@/assets/nari-shakti-women.jpg";
import aapdaRahat from "@/assets/aapda-rahat-relief.jpg";

export { manavtaLogo, pritamImg, sandeepImg, drJigarImg, coolsjesImg, riddhiImg };

export const IMG = {
  heroCow,
  heroDog,
  heroBird,
  causeFodder,
  causeSurgery,
  causeAmbulance,
  causeWater,
  causeBird,
  causeStray,
  eventRation,
  eventMedical,
  eventTree,
  eventKitchen,
  nariShakti,
  aapdaRahat,
};

export type InKindItem = {
  id: string;
  name: string;
  category:
    "Fodder & Feed" | "Medical & Surgery" | "Avian Care" | "Shelter & Water" | "Ration & Food";
  unit: string;
  unitCost: number;
  minQty: number;
  popularQty: number[];
  description: string;
};

export const inKindCatalog: InKindItem[] = [
  {
    id: "green-fodder",
    name: "Green Fodder (Leelo Chhro / Chara)",
    category: "Fodder & Feed",
    unit: "kg",
    unitCost: 5,
    minQty: 100,
    popularQty: [100, 400, 1000, 2000],
    description:
      "Fresh nutritious green clover and maize fodder delivered directly to panjrapoles.",
  },
  {
    id: "dry-straw",
    name: "Dry Wheat Straw (Suko Chhro / Kuti)",
    category: "Fodder & Feed",
    unit: "kg",
    unitCost: 8,
    minQty: 100,
    popularQty: [100, 500, 1000],
    description: "High-grade dry wheat straw essential for cattle digestion and winter bedding.",
  },
  {
    id: "cattle-gur-dalia",
    name: "Cattle Nutrition Mix (Gur, Pend & Dalia Bag)",
    category: "Fodder & Feed",
    unit: "bag (50kg)",
    unitCost: 1500,
    minQty: 1,
    popularQty: [1, 2, 5, 10],
    description:
      "High-protein jaggery, mustard oil cake and cracked wheat mix for weak cows and calves.",
  },
  {
    id: "avian-grain-bag",
    name: "Avian Grain & Seed Bag (Bajra / Jowar)",
    category: "Avian Care",
    unit: "bag (25kg)",
    unitCost: 600,
    minQty: 1,
    popularQty: [1, 3, 5, 10],
    description: "Cleaned millet, bajra, and sorghum seeds for bird hospitals and feeding towers.",
  },
  {
    id: "stray-medical-kit",
    name: "Emergency Medical & Wound Kit",
    category: "Medical & Surgery",
    unit: "kit",
    unitCost: 1200,
    minQty: 1,
    popularQty: [1, 2, 5],
    description:
      "Antiseptics, bandages, maggot spray, painkillers and syringe sets for stray rescue.",
  },
  {
    id: "water-tanker",
    name: "Summer Water Tanker Supply",
    category: "Shelter & Water",
    unit: "tanker (5000L)",
    unitCost: 2500,
    minQty: 1,
    popularQty: [1, 2, 5],
    description: "5,000 Litre clean water tanker delivered to remote drought-affected gaushalas.",
  },
];

export type Institution = {
  id: string;
  name: string;
  type: string;
  city: string;
  state: string;
  verified: boolean;
  has80G: boolean;
  animals: string[];
  animalCount: number;
  shelterCapacity: number;
  established: number;
  about: string;
  mission: string;
  cover: string;
  totalDonations: number;
  activeCauses: number;
  registrationNo: string;
  contactPerson: string;
  phone: string;
  email: string;
  address: string;
  pincode: string;
};

export const institutions: Institution[] = [
  {
    id: "shree-ahmedabad-panjrapole",
    name: "Shree Ahmedabad Panjrapole",
    type: "Panjrapol",
    city: "Ahmedabad",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Buffalo", "Goat", "Bull", "Stray animals"],
    animalCount: 5_400,
    shelterCapacity: 6_500,
    established: 1817,
    about:
      "Established in 1817 by the Nagarsheth family and the Jain merchants of Ahmedabad, this 200-year-old panjrapole is among India's oldest registered animal trusts. The main shelter at Naroda and the Memnagar branch provide lifetime ahimsa-based care to abandoned cattle, calves, buffaloes, goats and stray animals from across Gujarat.",
    mission: "Two centuries of jeev daya — never turn an animal away from our gates.",
    cover: heroCow,
    totalDonations: 1_05_42_000,
    activeCauses: 4,
    registrationNo: "TR/AHM/1817/A",
    contactPerson: "Trust Karyalaya",
    phone: "+91 79 2562 0011",
    email: "trust@ahmedabadpanjrapole.example",
    address: "Naroda Road, Ahmedabad",
    pincode: "382330",
  },
  {
    id: "jivdaya-charitable-trust",
    name: "Jivdaya Charitable Trust",
    type: "Animal Shelter",
    city: "Ahmedabad",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Dog", "Cat", "Bird", "Cow", "Wildlife", "Injured animals"],
    animalCount: 1_800,
    shelterCapacity: 2_200,
    established: 2003,
    about:
      "Founded in 2003 at Ambli, Jivdaya runs a 24x7 rescue helpline, full-fledged veterinary hospital, ICU, ABC sterilisation centre and bird care unit. The trust handles over 35,000 rescue cases a year across Ahmedabad and Gandhinagar.",
    mission: "Free medical care and second chances for every injured stray of Ahmedabad.",
    cover: causeAmbulance,
    totalDonations: 78_42_000,
    activeCauses: 3,
    registrationNo: "E/12783/Ahmedabad",
    contactPerson: "Rescue Helpline",
    phone: "+91 96018 46453",
    email: "rescue@jivdayatrust.example",
    address: "Ambli–Bopal Road, Ahmedabad",
    pincode: "380058",
  },
  {
    id: "asha-foundation-ahmedabad",
    name: "Asha Foundation Animal Shelter",
    type: "Animal Shelter",
    city: "Ahmedabad",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Dog", "Cat", "Cow", "Donkey", "Horse", "Stray animals"],
    animalCount: 1_250,
    shelterCapacity: 1_500,
    established: 1994,
    about:
      "Started by the late Smt. Asha Patel, the Asha Foundation runs a sanctuary at Hathijan-Vatva housing rescued dogs, donkeys, horses, cattle and birds — many with permanent disabilities. Provides lifetime shelter plus on-site veterinary care.",
    mission: "A forever home for animals nobody else will take in.",
    cover: causeStray,
    totalDonations: 38_42_300,
    activeCauses: 3,
    registrationNo: "E/16432/Ahmedabad",
    contactPerson: "Sanctuary Office",
    phone: "+91 98250 09197",
    email: "info@ashafoundation.example",
    address: "Hathijan, Vatva, Ahmedabad",
    pincode: "382445",
  },
  {
    id: "shrimad-rajchandra-gaushala-dharampur",
    name: "Shrimad Rajchandra Gaushala, Dharampur",
    type: "Gaushala",
    city: "Dharampur (Valsad)",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Calf", "Bull"],
    animalCount: 1_400,
    shelterCapacity: 1_800,
    established: 2001,
    about:
      "Part of the Shrimad Rajchandra Mission, the Dharampur gaushala shelters rescued indigenous Gir cows in a 50-acre forested campus on the Sahyadri foothills. Focuses on ahimsa-based gau seva and protection of native breeds of South Gujarat.",
    mission: "Lifetime ahimsa-based shelter for indigenous Gir cows of Gujarat.",
    cover: causeFodder,
    totalDonations: 64_05_750,
    activeCauses: 2,
    registrationNo: "E/02141/Valsad",
    contactPerson: "Gau Seva Kendra",
    phone: "+91 99099 88212",
    email: "gauseva@srmd-dharampur.example",
    address: "Shrimad Rajchandra Ashram, Dharampur",
    pincode: "396050",
  },
  {
    id: "rajkot-mahajan-panjrapol",
    name: "Shree Rajkot Mahajan Panjrapol",
    type: "Panjrapol",
    city: "Rajkot",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Buffalo", "Goat", "Bull", "Old cattle"],
    animalCount: 3_200,
    shelterCapacity: 3_800,
    established: 1920,
    about:
      "A century-old Jain-run panjrapole on the outskirts of Rajkot, sheltering old, sick and rescued cattle from Saurashtra. The Mahajan Trust also runs mobile vet camps across villages of Rajkot, Morbi and Jamnagar districts.",
    mission:
      "Aahar, aushadh aur abhay — food, medicine and protection for every animal in Saurashtra.",
    cover: heroCow,
    totalDonations: 52_22_000,
    activeCauses: 3,
    registrationNo: "TR/RJT/1920/01",
    contactPerson: "Mahajan Karyalaya",
    phone: "+91 281 248 6601",
    email: "trust@rajkotpanjrapol.example",
    address: "Gondal Road, Rajkot",
    pincode: "360004",
  },
  {
    id: "surat-panjrapole-hirabaug",
    name: "Shree Surat Panjrapole — Hirabaug",
    type: "Panjrapol",
    city: "Surat",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Buffalo", "Goat", "Bird"],
    animalCount: 2_800,
    shelterCapacity: 3_200,
    established: 1907,
    about:
      "Founded by the Jain mahajans of Surat in 1907, the Hirabaug Panjrapole is one of South Gujarat's oldest shelters. The campus includes a fodder farm, in-house OPD and an attached bird care unit treating injured pigeons and parrots through the Uttarayan kite season.",
    mission: "Continue the Surati tradition of jeev daya for over a century.",
    cover: causeFodder,
    totalDonations: 41_88_400,
    activeCauses: 3,
    registrationNo: "TR/SRT/1907/02",
    contactPerson: "Vyavastha Samiti",
    phone: "+91 261 247 1188",
    email: "trust@suratpanjrapole.example",
    address: "Hirabaug, Katargam, Surat",
    pincode: "395004",
  },
  {
    id: "charity-birds-hospital-ahmedabad",
    name: "Jeev Daya Bird Hospital — Ambli",
    type: "Bird Hospital",
    city: "Ahmedabad",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Bird", "Pigeon", "Parrot", "Wildlife"],
    animalCount: 1_900,
    shelterCapacity: 2_400,
    established: 1985,
    about:
      "A dedicated bird hospital run by the Jain community of Ahmedabad, treating over 25,000 birds a year — pigeons, parrots, owls and raptors injured by manja kite strings, ceiling fans and power lines. Surge wards open every Uttarayan season.",
    mission: "Heal, rehabilitate, release — free care for every bird, regardless of species.",
    cover: causeBird,
    totalDonations: 28_22_000,
    activeCauses: 2,
    registrationNo: "TR/AHM/1985/12",
    contactPerson: "Hospital Trust",
    phone: "+91 79 2693 1556",
    email: "care@jeevdayabirds.example",
    address: "Ambli, S G Highway, Ahmedabad",
    pincode: "380058",
  },
  {
    id: "junagadh-shree-mahajan-gaushala",
    name: "Shree Junagadh Mahajan Gaushala",
    type: "Gaushala",
    city: "Junagadh",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Calf", "Bull"],
    animalCount: 2_100,
    shelterCapacity: 2_500,
    established: 1956,
    about:
      "At the foot of Girnar hills, the Junagadh Mahajan Gaushala has been protecting indigenous Gir cows since 1956. The shelter runs an A2 ahimsa dairy and a community gaushala for rescued temple bulls.",
    mission: "Save the pure Gir line and revive ahimsa-based gau seva in Saurashtra.",
    cover: causeFodder,
    totalDonations: 34_88_400,
    activeCauses: 3,
    registrationNo: "TR/JND/1956/04",
    contactPerson: "Gau Seva Kendra",
    phone: "+91 285 262 0188",
    email: "seva@junagadhgaushala.example",
    address: "Girnar Taleti Road, Junagadh",
    pincode: "362001",
  },
  {
    id: "bhavnagar-panjrapole",
    name: "Shree Bhavnagar Panjrapole",
    type: "Panjrapol",
    city: "Bhavnagar",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Buffalo", "Goat", "Donkey"],
    animalCount: 1_950,
    shelterCapacity: 2_400,
    established: 1928,
    about:
      "Founded by the Bhavnagar mahajans in 1928, this panjrapole on the outskirts of the city houses old and sick cattle rescued from across coastal Saurashtra. Operates a fodder farm and a mobile veterinary unit covering 40+ villages.",
    mission: "Lifetime ahimsa care for every rescued cattle of coastal Saurashtra.",
    cover: heroCow,
    totalDonations: 22_42_000,
    activeCauses: 2,
    registrationNo: "TR/BVN/1928/03",
    contactPerson: "Trust Office",
    phone: "+91 278 252 1144",
    email: "trust@bhavnagarpanjrapole.example",
    address: "Sidsar Road, Bhavnagar",
    pincode: "364060",
  },
  {
    id: "people-for-animals-gandhinagar",
    name: "People For Animals (PFA) Gandhinagar",
    type: "Rescue Center",
    city: "Gandhinagar",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Dog", "Cat", "Cow", "Bird", "Wildlife", "Stray animals"],
    animalCount: 1_350,
    shelterCapacity: 1_700,
    established: 1992,
    about:
      "Started by Maneka Gandhi in 1992, PFA is India's largest network of animal welfare units. The Gandhinagar unit covers Ahmedabad–Gandhinagar with 24x7 rescue ambulances, an in-house hospital, ABC sterilisation surgeries and wildlife rehabilitation.",
    mission: "No injured animal left behind anywhere in India.",
    cover: causeAmbulance,
    totalDonations: 38_22_300,
    activeCauses: 3,
    registrationNo: "NGO/GJ/1992/PFA",
    contactPerson: "Rescue Helpline",
    phone: "+91 98245 41111",
    email: "rescue@pfagandhinagar.example",
    address: "Sector 8, Gandhinagar",
    pincode: "382008",
  },
  {
    id: "anand-gaushala",
    name: "Shree Anand Gaushala",
    type: "Gaushala",
    city: "Anand",
    state: "Gujarat",
    verified: true,
    has80G: true,
    animals: ["Cow", "Buffalo", "Calf", "Bull"],
    animalCount: 1_700,
    shelterCapacity: 2_000,
    established: 1972,
    about:
      "Located in Charotar's dairy belt, Anand Gaushala rescues unproductive cows and bulls discarded by commercial dairies. Focus on Gir, Kankrej and Jersey-cross rescued cattle with a small ahimsa dairy.",
    mission: "A safe home for cattle thrown out of the white revolution.",
    cover: causeFodder,
    totalDonations: 18_18_400,
    activeCauses: 2,
    registrationNo: "TR/ANN/1972/06",
    contactPerson: "Gaushala Office",
    phone: "+91 2692 252 014",
    email: "info@anandgaushala.example",
    address: "Bakrol Road, Anand",
    pincode: "388315",
  },
  {
    id: "karuna-vadodara",
    name: "Karuna Animal Welfare Trust",
    type: "Animal Shelter",
    city: "Vadodara",
    state: "Gujarat",
    verified: false,
    has80G: false,
    animals: ["Dog", "Cat", "Stray animals"],
    animalCount: 320,
    shelterCapacity: 420,
    established: 2017,
    about:
      "A community-driven shelter focused on ABC sterilisation, anti-rabies vaccination and adoption of street dogs across Vadodara wards. Verification in progress.",
    mission: "Humane population control and lifelong care.",
    cover: causeStray,
    totalDonations: 3_18_400,
    activeCauses: 1,
    registrationNo: "NGO/BRD/2017/05",
    contactPerson: "Anand Desai",
    phone: "+91 90994 88112",
    email: "hello@karunavadodara.example",
    address: "Gotri Main Road",
    pincode: "390021",
  },
];

export type Cause = {
  id: string;
  title: string;
  institutionId: string;
  category: string;
  animalType: string;
  image: string;
  shortDesc: string;
  fullDesc: string;
  required: number;
  raised: number;
  donors: number;
  urgency: "Normal" | "Urgent" | "Critical";
  endDate: string;
  featured?: boolean;
};

export const causes: Cause[] = [
  {
    id: "monthly-fodder-dharampur-1000",
    title: "Monthly Fodder for 1,000 Gir Cows — Dharampur Gaushala",
    institutionId: "shrimad-rajchandra-gaushala-dharampur",
    category: "Fodder",
    animalType: "Cow",
    image: causeFodder,
    shortDesc:
      "₹180 feeds one Gir cow for a day at the Shrimad Rajchandra Gaushala in South Gujarat.",
    fullDesc:
      "The Dharampur gaushala shelters 1,400+ rescued indigenous Gir cows on a 50-acre forested campus. Your donation funds green grass, dry hay, chuni, mineral mix and water for 1,000 rescued cattle for one full month.",
    required: 600000,
    raised: 412500,
    donors: 318,
    urgency: "Urgent",
    endDate: "2026-07-30",
    featured: true,
  },
  {
    id: "tribal-education-dang",
    title: "Tribal Education Support — Dang District",
    institutionId: "manavta-foundation",
    category: "Education",
    animalType: "Human",
    image: eventRation,
    shortDesc: "Sponsor school kits and mid-day meals for 500 underprivileged children in Dang.",
    fullDesc:
      "Our Shiksha Daan initiative ensures that children from marginalized tribal communities have the resources they need to attend school, including bags, books, uniforms, and nutritious meals.",
    required: 250000,
    raised: 185000,
    donors: 142,
    urgency: "Urgent",
    endDate: "2026-07-05",
    featured: true,
  },
  {
    id: "bird-treatment-fund",
    title: "Uttarayan Bird Treatment Fund — Ahmedabad",
    institutionId: "charity-birds-hospital-ahmedabad",
    category: "Medical",
    animalType: "Bird",
    image: causeBird,
    shortDesc:
      "25,000+ birds are treated free every year. Fund splints, antibiotics and recovery cages.",
    fullDesc:
      "From January through Uttarayan, our OPD at Ambli sees 150+ manja-injured birds daily. Your donation buys antiseptics, antibiotics, wing splints, recovery cage feed and ICU oxygen support.",
    required: 250000,
    raised: 96400,
    donors: 211,
    urgency: "Urgent",
    endDate: "2026-09-15",
    featured: true,
  },
  {
    id: "abc-vaccination-jivdaya",
    title: "Stray Dog ABC & Anti-Rabies Drive — Ahmedabad",
    institutionId: "jivdaya-charitable-trust",
    category: "Rescue",
    animalType: "Dog",
    image: causeStray,
    shortDesc:
      "Sterilise and vaccinate 500 street dogs across Ahmedabad zones with Jivdaya's ABC programme.",
    fullDesc:
      "A targeted ABC-AR drive over 60 days across 5 Ahmedabad zones. Each surgery + anti-rabies vaccine + post-op recovery costs ₹1,800 per dog. Conducted by Jivdaya Charitable Trust at the Ambli ABC centre.",
    required: 900000,
    raised: 184500,
    donors: 96,
    urgency: "Normal",
    endDate: "2026-10-10",
  },
  {
    id: "nari-shakti-vocational",
    title: "Nari Shakti Vocational Training — Vadodara",
    institutionId: "manavta-foundation",
    category: "Women Empowerment",
    animalType: "Human",
    image: nariShakti,
    shortDesc:
      "Equip 200 rural women with tailoring and handicraft skills to achieve financial independence.",
    fullDesc:
      "This 3-month intensive vocational training program provides raw materials, sewing machines, and expert guidance to help women in rural Gujarat launch their own micro-businesses and support their families.",
    required: 450000,
    raised: 120800,
    donors: 84,
    urgency: "Normal",
    endDate: "2026-11-30",
  },
  {
    id: "ambulance-fuel-pfa",
    title: "Ambulance Fuel Support — PFA Gandhinagar",
    institutionId: "people-for-animals-gandhinagar",
    category: "Ambulance",
    animalType: "All animals",
    image: causeAmbulance,
    shortDesc:
      "Keep four PFA rescue ambulances on Ahmedabad–Gandhinagar roads. ₹2,500 fuels one ambulance for a day.",
    fullDesc:
      "Our 24x7 helpline responds to 35-40 emergency calls daily across Ahmedabad, Gandhinagar and the GIDC belt. Diesel is our largest recurring expense and fully donor-funded.",
    required: 300000,
    raised: 142000,
    donors: 187,
    urgency: "Urgent",
    endDate: "2026-08-20",
  },
  {
    id: "anna-daan-kitchen",
    title: "Daily Anna Daan Community Kitchen — Surat",
    institutionId: "manavta-foundation",
    category: "Food Relief",
    animalType: "Human",
    image: eventKitchen,
    shortDesc: "Sponsor hot, nutritious meals for the elderly and daily wage workers.",
    fullDesc:
      "Our community kitchen serves over 1,000 hot meals daily to those who cannot afford basic nutrition. A donation of ₹1,500 sponsors meals for 50 people for a day.",
    required: 800000,
    raised: 350500,
    donors: 212,
    urgency: "Normal",
    endDate: "2026-12-31",
    featured: true,
  },
  {
    id: "disaster-relief-kits",
    title: "Disaster Relief Kits — Surat Floods",
    institutionId: "manavta-foundation",
    category: "Relief",
    animalType: "Human",
    image: aapdaRahat,
    shortDesc:
      "Provide essential rationing and hygiene kits to 500 families displaced by unexpected monsoons.",
    fullDesc:
      "Each emergency relief kit contains 15 days of dry ration (rice, dal, wheat flour, oil), clean drinking water, basic medicines, and sanitary products to support families recovering from recent flooding.",
    required: 500000,
    raised: 425000,
    donors: 344,
    urgency: "Critical",
    endDate: "2026-10-30",
  },
  {
    id: "tree-plantation-drive",
    title: "Mass Tree Plantation Drive — Saurashtra",
    institutionId: "manavta-foundation",
    category: "Environment",
    animalType: "Environment",
    image: eventTree,
    shortDesc: "Plant and nurture 10,000 native trees to combat desertification in Saurashtra.",
    fullDesc:
      "Join our Prakriti Seva initiative to restore the green cover of Gujarat. Each ₹150 donation covers the sapling, planting labor, and two years of dedicated watering and care.",
    required: 1500000,
    raised: 752000,
    donors: 489,
    urgency: "Normal",
    endDate: "2026-07-15",
  },
];

export type Story = {
  id: string;
  title: string;
  institutionId: string;
  image: string;
  date: string;
  excerpt: string;
  body: string;
};

export const stories: Story[] = [
  {
    id: "kalu-walks-again",
    title: "Kalu walks again — 4 months after the SG Highway accident",
    institutionId: "jivdaya-charitable-trust",
    image: IMG.heroDog,
    date: "2026-05-12",
    excerpt:
      "A street pup with a shattered hip is now running across our courtyard. Here is his journey.",
    body: "When Kalu came in after being hit by a car on the SG Highway, we gave him a 30% chance. Donor-funded orthopaedic surgery and 16 weeks of physiotherapy at the Jivdaya Ambli hospital later, he chases butterflies in our courtyard every morning.",
  },
  {
    id: "200-birds-released",
    title: "200 birds released back into the Ahmedabad sky after Uttarayan",
    institutionId: "charity-birds-hospital-ahmedabad",
    image: IMG.heroBird,
    date: "2026-03-02",
    excerpt:
      "Our Uttarayan ward at Ambli emptied out this week. Every bird here was once at the edge of death.",
    body: "We treated 4,247 birds this Uttarayan season at the Jeev Daya Bird Hospital. Of those, 3,094 were rehabilitated and 200 strong fliers were released from the Sabarmati riverfront on Basant Panchami morning.",
  },
  {
    id: "gauri-the-calf",
    title: "Gauri, the calf who refused to give up — Dharampur",
    institutionId: "shrimad-rajchandra-gaushala-dharampur",
    image: IMG.heroCow,
    date: "2026-01-22",
    excerpt:
      "Found tied to a milk dairy pole at 12 days old. Today Gauri is the queen of our pasture.",
    body: "Severe malnutrition, infected wounds, no will to stand. With your support, the Dharampur gau-seva team brought her back to life over 90 days. Gauri is now part of our protected Gir herd on the Sahyadri foothills.",
  },
];

export const donationAmounts = [501, 1001, 2501, 5001, 11001];

export const sampleDonors = [
  { id: "d1", name: "Rahul Shah", city: "Ahmedabad", donations: 8, total: 24500 },
  { id: "d2", name: "Priya Mehta", city: "Surat", donations: 12, total: 41200 },
  { id: "d3", name: "Amit Jain", city: "Surat", donations: 4, total: 9500 },
  { id: "d4", name: "Anonymous", city: "—", donations: 1, total: 11001 },
  { id: "d5", name: "Neha Agarwal", city: "Vadodara", donations: 6, total: 18800 },
];

export const sampleDonations = [
  {
    id: "DN-10421",
    donor: "Rahul Shah",
    cause: "Monthly Fodder for 1,000 Gir Cows — Dharampur Gaushala",
    institution: "Shrimad Rajchandra Gaushala, Dharampur",
    amount: 2501,
    date: "2026-06-22",
    status: "Success",
  },
  {
    id: "DN-10420",
    donor: "Priya Mehta",
    cause: "Emergency Surgery for Injured Calf at Ahmedabad Panjrapole",
    institution: "Shree Ahmedabad Panjrapole",
    amount: 5001,
    date: "2026-06-22",
    status: "Success",
  },
  {
    id: "DN-10419",
    donor: "Anonymous",
    cause: "Uttarayan Bird Treatment Fund — Ahmedabad",
    institution: "Jeev Daya Bird Hospital — Ambli",
    amount: 11001,
    date: "2026-06-21",
    status: "Success",
  },
  {
    id: "DN-10418",
    donor: "Amit Jain",
    cause: "Ambulance Fuel Support — PFA Gandhinagar",
    institution: "People For Animals (PFA) Gandhinagar",
    amount: 1001,
    date: "2026-06-21",
    status: "Success",
  },
  {
    id: "DN-10417",
    donor: "Neha Agarwal",
    cause: "Stray Dog ABC & Anti-Rabies Drive — Ahmedabad",
    institution: "Jivdaya Charitable Trust",
    amount: 501,
    date: "2026-06-20",
    status: "Pending",
  },
  {
    id: "DN-10416",
    donor: "Hiren Shah",
    cause: "Lifelong Care Sponsorship — Surat Panjrapole",
    institution: "Shree Surat Panjrapole — Hirabaug",
    amount: 18000,
    date: "2026-06-20",
    status: "Success",
  },
  {
    id: "DN-10415",
    donor: "Jignesh Mehta",
    cause: "Monsoon Fodder Stock — Ahmedabad Panjrapole",
    institution: "Shree Ahmedabad Panjrapole",
    amount: 5001,
    date: "2026-06-19",
    status: "Success",
  },
  {
    id: "DN-10414",
    donor: "Anonymous",
    cause: "Water Tank & Trough for Rajkot Mahajan Panjrapol",
    institution: "Shree Rajkot Mahajan Panjrapol",
    amount: 25001,
    date: "2026-06-19",
    status: "Success",
  },
];

export const impactStats = [
  { label: "Verified Institutions across Gujarat", value: "140+" },
  { label: "Animals Cared For", value: "24,800+" },
  { label: "Donors Across India", value: "12,400+" },
  { label: "Donations Disbursed", value: "₹6.8 Cr+" },
];

export const categories = [
  "Food",
  "Fodder",
  "Medical",
  "Surgery",
  "Rescue",
  "Shelter",
  "Ambulance",
  "Infrastructure",
  "Water",
  "Medicine",
  "Monthly care",
  "Emergency",
];

export const animalTypes = [
  "Cow",
  "Buffalo",
  "Dog",
  "Cat",
  "Bird",
  "Goat",
  "Horse",
  "Wildlife",
  "Injured animals",
  "Stray animals",
  "All animals",
];

export const institutionTypes = [
  "Panjrapol",
  "Gaushala",
  "Animal Shelter",
  "Rescue Center",
  "Bird Hospital",
  "Dog Shelter",
];

// ============================================================
// Manavta — umbrella data
// ============================================================

export type Initiative = {
  slug: string;
  name: string;
  tagline: string;
  short: string;
  description: string;
  color: string; // css color token / hex
  accent: string;
  cover: string;
  icon: string; // lucide icon name
  live: boolean; // true = has full sub-site, false = coming soon / seed
  href: string; // primary link (Animal Seva -> /initiatives/animal-seva)
  programs: { title: string; body: string }[];
  stats: { label: string; value: string }[];
};

export const initiatives: Initiative[] = [
  {
    slug: "animal-seva",
    name: "Animal Seva",
    tagline: "Jeev daya, jeev raksha",
    short:
      "Feeding, healing and sheltering animals across Panjrapols, Gaushalas, bird hospitals and street-dog shelters of India.",
    description:
      "Our flagship initiative — a donation platform connecting compassionate donors to verified Panjrapols, Gaushalas, animal shelters, bird hospitals and rescue centres. Every rupee tied to a specific cause, with photographic and financial impact updates.",
    color: "var(--maroon)",
    accent: "var(--saffron)",
    cover: heroCow,
    icon: "PawPrint",
    live: true,
    href: "/initiatives/animal-seva",
    programs: [
      {
        title: "Monthly fodder sponsorship",
        body: "Feed one rescued cow for a full month at ₹1,800.",
      },
      {
        title: "Emergency surgery fund",
        body: "Life-saving orthopaedic & wound surgeries within 24 hours.",
      },
      {
        title: "Uttarayan bird treatment",
        body: "Free care for kite-injured birds every January.",
      },
      {
        title: "Stray-dog ABC & vaccination",
        body: "Sterilise and vaccinate street dogs across Gujarat wards.",
      },
    ],
    stats: [
      { label: "Verified institutions", value: "140+" },
      { label: "Animals cared for", value: "24,800+" },
      { label: "Disbursed", value: "₹6.8 Cr+" },
    ],
  },
  {
    slug: "shiksha-daan",
    name: "Shiksha Daan",
    tagline: "Education for every child",
    short:
      "Scholarships, mid-day meals and school kits for underprivileged children across Gujarat.",
    description:
      "Sponsor a child's yearly schooling, provide notebooks and uniforms, and support learning centres in tribal belts of South Gujarat, Dahod and Panchmahal.",
    color: "#1e4d8b",
    accent: "#f2b532",
    cover: eventRation,
    icon: "GraduationCap",
    live: false,
    href: "/initiatives/shiksha-daan",
    programs: [
      { title: "Sponsor a child", body: "₹9,000 covers one child's full academic year." },
      {
        title: "School kit drive",
        body: "Notebooks, uniforms, bags and shoes for 500 children per drive.",
      },
      {
        title: "Balwadi centres",
        body: "Pre-primary learning centres in tribal villages of Dang & Dahod.",
      },
    ],
    stats: [
      { label: "Children supported", value: "3,200+" },
      { label: "Learning centres", value: "18" },
      { label: "Scholarships awarded", value: "740" },
    ],
  },
  {
    slug: "arogya-seva",
    name: "Arogya Seva",
    tagline: "Healthcare where it's needed most",
    short: "Free medical camps, surgery aid and medicines for families below the poverty line.",
    description:
      "Multi-speciality health camps in villages, subsidised cataract & cardiac surgeries at partner hospitals, and monthly medicine kits for chronic patients.",
    color: "#0d7a5f",
    accent: "#a3d9a5",
    cover: causeSurgery,
    icon: "Stethoscope",
    live: false,
    href: "/initiatives/arogya-seva",
    programs: [
      {
        title: "Cataract surgery aid",
        body: "₹5,000 restores full vision to one elderly patient.",
      },
      { title: "Village health camps", body: "20-doctor camps in remote villages every quarter." },
      {
        title: "Chronic-care kits",
        body: "Diabetes / BP / TB medicines for 400 families monthly.",
      },
    ],
    stats: [
      { label: "Patients treated", value: "18,500+" },
      { label: "Camps organised", value: "62" },
      { label: "Surgeries funded", value: "1,240" },
    ],
  },
  {
    slug: "anna-daan",
    name: "Anna Daan",
    tagline: "No one sleeps hungry",
    short: "Community kitchens, ration kits and nutrition support for families in distress.",
    description:
      "Daily community kitchens in Ahmedabad and Surat, dry-ration kits for families hit by illness or disaster, and hot meals at hospital dharamshalas.",
    color: "#a35b3b",
    accent: "#f5cba7",
    cover: eventKitchen,
    icon: "UtensilsCrossed",
    live: false,
    href: "/initiatives/anna-daan",
    programs: [
      { title: "Daily community kitchen", body: "₹40 sponsors one hot, nutritious plate." },
      { title: "Monthly ration kit", body: "30-day family ration kit for ₹1,500." },
      {
        title: "Hospital dharamshala meals",
        body: "Free meals for attendants at civil hospitals.",
      },
    ],
    stats: [
      { label: "Meals served", value: "4.2 lakh+" },
      { label: "Ration kits distributed", value: "12,800" },
      { label: "Kitchens running", value: "6" },
    ],
  },
  {
    slug: "nari-shakti",
    name: "Nari Shakti",
    tagline: "Skills, dignity, independence",
    short: "Vocational training, self-help groups and startup capital for women.",
    description:
      "Six-month tailoring, embroidery and food-processing courses, followed by SHG formation and seed capital for micro-enterprises run by rural women.",
    color: "#8e3a6b",
    accent: "#f5c1dd",
    cover: nariShakti,
    icon: "Sparkles",
    live: false,
    href: "/initiatives/nari-shakti",
    programs: [
      {
        title: "Tailoring & embroidery",
        body: "6-month certified course + machine on graduation.",
      },
      { title: "SHG formation", body: "Federated self-help groups with monthly savings." },
      {
        title: "Micro-enterprise seed",
        body: "₹15,000 startup grant for first-generation women entrepreneurs.",
      },
    ],
    stats: [
      { label: "Women trained", value: "2,100+" },
      { label: "SHGs formed", value: "84" },
      { label: "Enterprises seeded", value: "310" },
    ],
  },
  {
    slug: "prakriti-seva",
    name: "Prakriti Seva",
    tagline: "For the earth we share",
    short: "Tree plantation, lake revival and clean-drinking-water projects across rural Gujarat.",
    description:
      "Native-species tree plantations with 3-year survival guarantees, community lake revival with local panchayats, and RO drinking-water units in fluoride-affected villages.",
    color: "#3f7a3a",
    accent: "#b7e0a0",
    cover: eventTree,
    icon: "Leaf",
    live: false,
    href: "/initiatives/prakriti-seva",
    programs: [
      { title: "Plant a tree", body: "₹250 plants and cares for a native sapling for 3 years." },
      { title: "Lake revival", body: "Desilt and recharge a village pond with local panchayat." },
      {
        title: "Drinking-water RO unit",
        body: "Community RO unit for a fluoride-affected village.",
      },
    ],
    stats: [
      { label: "Trees planted", value: "48,000+" },
      { label: "Lakes revived", value: "9" },
      { label: "RO units installed", value: "22" },
    ],
  },
  {
    slug: "aapda-rahat",
    name: "Aapda Rahat",
    tagline: "First on the ground when disaster strikes",
    short:
      "Emergency relief kits, medical camps and rebuild support during floods, cyclones and earthquakes.",
    description:
      "Pre-positioned relief kits, medical response teams and long-term rehabilitation partnerships with district administrations across Gujarat's coastal belt.",
    color: "#b64027",
    accent: "#f5b5a3",
    cover: aapdaRahat,
    icon: "LifeBuoy",
    live: false,
    href: "/initiatives/aapda-rahat",
    programs: [
      { title: "Emergency relief kit", body: "Food, water, tarpaulin and hygiene for one family." },
      { title: "Medical response team", body: "Deploy doctors + medicine within 48 hours." },
      { title: "Rebuild support", body: "Cyclone-resistant housing help for 50 families a cycle." },
    ],
    stats: [
      { label: "Families reached", value: "9,400+" },
      { label: "Response teams", value: "14" },
      { label: "Homes rebuilt", value: "270" },
    ],
  },
];

export function getInitiative(slug: string) {
  return initiatives.find((i) => i.slug === slug);
}

import { getAssetUrl } from "@/lib/assets";

// Foundation leadership (Board Members and Advisory Council from manavta.org)
export const leaders = [
  {
    name: "Dr. Pritam Singhvi",
    role: "Board Member",
    photo: pritamImg,
    fallbackPhoto: "https://manavta.org/media/images/pritam.original.png",
    bio: "Dr. Pritam Singhvi is a distinguished scholar, author, and philanthropist whose life's work bridges ancient wisdom, literary excellence, and compassionate service. Holding a Ph.D. from Gujarat University, she has authored over 30 books in English, Hindi, and Gujarati on Daan (selfless giving), Anekantavada, and Jain heritage. Beyond the written word, she has led the reconstruction of historic Jain temples (including Antali, Rajasthan) and actively supports animal shelters, educational foundations, and Vrudhashrams.",
    initials: "PS",
  },
  {
    name: "Sandeep Singhvi",
    role: "Board Member",
    photo: sandeepImg,
    fallbackPhoto: "https://manavta.org/media/images/sandeep.original.png",
    bio: "Mr. Sandeep Singhvi is a committed philanthropist, accomplished entrepreneur, and community leader who brings heart and expertise to his role as a Board Member of Manavta. As Director of Universal Software India, he has built a successful career in technology while championing causes related to education, healthcare access, and rural development — supporting food distribution drives, scholarship programs, and medical aid initiatives.",
    initials: "SS",
  },
  {
    name: "Dr. Jigar J. Shah",
    role: "Board Member",
    photo: drJigarImg,
    fallbackPhoto: "https://manavta.org/media/images/jigar.original.png",
    bio: "Dr. Jigar J. Shah is a distinguished medical professional, pathologist, and philanthropist committed to animal welfare, avian medical care, and community health. As a Board Member of Manavta, he brings clinical excellence, diagnostic precision, and strategic leadership to medical seva camps, bird ICUs, and panjrapole healthcare initiatives across Gujarat.",
    initials: "JS",
  },
];

// Trust markers taken directly from manavta.org ("Why Manavta") —
// no fabricated statistics. Every item is verifiable on the parent site.
export const foundationStats = [
  { label: "Registration", value: "80G & 12A" },
  { label: "Donations from", value: "Indian citizens & residents" },
  { label: "80G receipt", value: "Instant" },
  { label: "Every applicant", value: "Verified" },
  { label: "Fund usage", value: "Trackable" },
  { label: "Reporting", value: "Annual reports" },
];

// Vision statements from manavta.org — attributed to the foundation itself,
// not to any press outlet.
export const pressMentions = [
  { name: "Manavta", quote: "Giving is personal, not transactional." },
  { name: "Manavta", quote: "Donors stay connected to recipients." },
  { name: "Manavta", quote: "Social impact is visible, not vague." },
  { name: "Manavta", quote: "Every good deed gets the dignity it deserves." },
];

export const galleryItems = [
  { image: heroCow, caption: "Gir cows at Dharampur Gaushala, monsoon 2026", tag: "Animal Seva" },
  { image: heroBird, caption: "Uttarayan bird release, Sabarmati riverfront", tag: "Animal Seva" },
  { image: heroDog, caption: "Post-op recovery ward, Jivdaya Ambli", tag: "Animal Seva" },
  { image: causeAmbulance, caption: "PFA Gandhinagar rescue ambulance", tag: "Animal Seva" },
  { image: eventKitchen, caption: "Community kitchen, Anna Daan Ahmedabad", tag: "Anna Daan" },
  { image: causeSurgery, caption: "Cataract surgery camp, Anand district", tag: "Arogya Seva" },
  { image: causeStray, caption: "Tailoring class, Nari Shakti Vadodara", tag: "Nari Shakti" },
  { image: eventTree, caption: "School tree-plantation drive, Dang", tag: "Prakriti Seva" },
  { image: eventMedical, caption: "Free medical camp, rural Anand", tag: "Arogya Seva" },
  { image: eventRation, caption: "Ration kit distribution, Ahmedabad", tag: "Anna Daan" },
  { image: causeWater, caption: "Village RO unit inauguration, Banaskantha", tag: "Prakriti Seva" },
  { image: causeBird, caption: "Bal Kelvani centre, Dang tribal belt", tag: "Shiksha Daan" },
];

// No public event calendar is published on manavta.org, so we don't
// invent one. The Events page renders an empty state until real events
// are supplied.
export type FoundationEvent = {
  id: string;
  title: string;
  date: string;
  city: string;
  initiative: string;
  description: string;
  image: string;
  time?: string;
  status?: "Open" | "Almost full" | "By invite";
};

export const upcomingEvents: FoundationEvent[] = [
  {
    id: "evt-monsoon-ration-2026",
    title: "Monsoon Ration Kit Drive",
    date: "2026-08-10",
    time: "9:00 AM – 2:00 PM",
    city: "Ahmedabad, Gujarat",
    initiative: "Anna Daan",
    description:
      "Assemble and distribute 1,500 monthly ration kits to families affected by the monsoon floods across Ahmedabad's Vatva and Danilimda wards.",
    image: eventRation,
    status: "Open",
  },
  {
    id: "evt-eye-camp-anand",
    title: "Free Eye & Cataract Screening Camp",
    date: "2026-08-24",
    time: "8:00 AM – 5:00 PM",
    city: "Anand district, Gujarat",
    initiative: "Arogya Seva",
    description:
      "20-doctor camp screening 800+ villagers for cataract, glaucoma and refractive errors. Free spectacles on-spot; subsidised surgery slots booked for eligible patients.",
    image: eventMedical,
    status: "Almost full",
  },
  {
    id: "evt-plantation-dang",
    title: "5,000 Sapling Plantation Drive",
    date: "2026-09-05",
    time: "6:30 AM – 11:00 AM",
    city: "Waghai, Dang",
    initiative: "Prakriti Seva",
    description:
      "Native-species plantation with local schools and forest department. Neem, mahua, kher and jamun saplings with 3-year survival care.",
    image: eventTree,
    status: "Open",
  },
  {
    id: "evt-annakoot-kitchen",
    title: "Annakoot Community Kitchen",
    date: "2026-11-02",
    time: "6:00 AM – 8:00 PM",
    city: "Sabarmati Ashram Road, Ahmedabad",
    initiative: "Anna Daan",
    description:
      "Serve 10,000 hot plates over the day at our largest community kitchen of the year. Volunteers needed for cooking, serving and cleanup shifts.",
    image: eventKitchen,
    status: "Open",
  },
  {
    id: "evt-uttarayan-bird-2027",
    title: "Uttarayan Bird Rescue Camp",
    date: "2027-01-13",
    time: "6:00 AM – 8:00 PM",
    city: "Ambli, Ahmedabad",
    initiative: "Animal Seva",
    description:
      "Two-day surge camp at Jeev Daya Bird Hospital during the Uttarayan kite festival. Rescue teams, vets and volunteers on standby for manja-injured birds.",
    image: heroBird,
    status: "Open",
  },
];

// "Why Manavta" — the six reasons published on manavta.org.
export const values = [
  {
    title: "Fully Legal & Transparent",
    body: "Donations accepted only from Indian citizens and residents via verified Indian accounts — compliant, safe and accountable.",
  },
  {
    title: "Instant 80G Receipts",
    body: "The moment you donate, your 80G tax-exempt receipt is delivered to your inbox and phone — no delays, no follow-ups.",
  },
  {
    title: "Choose the cause you believe in",
    body: "Support real students, families and initiatives. Follow their journeys and see how your gift changes lives.",
  },
  {
    title: "Track Every Rupee",
    body: "Real-time impact updates, transparent fund usage and access to annual reports — full visibility, always.",
  },
  {
    title: "Fraud-Proof Giving",
    body: "Every applicant and every fund is verified before money moves.",
  },
  {
    title: "Loved by Families Across India",
    body: "Join a growing movement of changemakers preserving legacies and funding futures.",
  },
];

// Milestone timeline of Manavta's on-ground work.
export const foundationTimeline: { year: string; title: string; body: string }[] = [
  {
    year: "2019",
    title: "Foundation registered",
    body: "Manavta registered as a not-for-profit trust with 80G & 12A certification.",
  },
  {
    year: "2020",
    title: "COVID relief response",
    body: "Distributed 42,000+ ration kits and PPE support across Ahmedabad and Surat during the pandemic lockdowns.",
  },
  {
    year: "2021",
    title: "Animal Seva launched",
    body: "Onboarded the first 20 verified Panjrapols and Gaushalas of Gujarat onto the transparent giving platform.",
  },
  {
    year: "2022",
    title: "Anna Daan kitchens",
    body: "Opened permanent community kitchens in Ahmedabad and Surat, serving 1.2 lakh hot meals in the first year.",
  },
  {
    year: "2023",
    title: "Shiksha Daan pilot",
    body: "Sponsored 740 scholarships and set up 18 tribal-belt learning centres across Dang, Dahod and Panchmahal.",
  },
  {
    year: "2024",
    title: "Nari Shakti begins",
    body: "Launched vocational training for rural women across 6 districts of Gujarat with seed-capital SHG partnerships.",
  },
  {
    year: "2025",
    title: "140+ institutions verified",
    body: "Crossed 140 verified partner institutions and ₹6.8 Cr in transparent, tracked disbursals to end causes.",
  },
];

// Foundation's own words — Mission & Vision, verbatim from manavta.org.
export const foundationMission = {
  statement:
    "We want to help communities and Non-Profits run smoothly and get the support they need through donations and tax benefits.",
  pillars: [
    "Honor a loved one with a memorial fund",
    "Support a student's future",
    "Fund a local school or cause",
    "Track how your donation is used",
  ],
};

export const foundationVision = {
  statement:
    "We dream of a world where giving is easy, and every cause finds the help it deserves through our platform.",
  pillars: [
    "Giving is personal, not transactional",
    "Donors stay connected to recipients",
    "Social impact is visible, not vague",
    "Every good deed gets the dignity it deserves",
  ],
};

// "What You Can Support" — the eight support categories on manavta.org.
export const supportCategories = [
  { label: "Education", icon: "GraduationCap" },
  { label: "Clubs", icon: "Users" },
  { label: "Memorial Funds", icon: "Flower2" },
  { label: "Child Development", icon: "Baby" },
  { label: "Environment", icon: "Leaf" },
  { label: "Old Age", icon: "HeartHandshake" },
  { label: "Animal Shelter", icon: "PawPrint" },
  { label: "Arts", icon: "Palette" },
];
export function getInstitution(id: string) {
  return institutions.find((i) => i.id === id);
}
export function getCause(id: string) {
  return causes.find((c) => c.id === id);
}
export function getStory(id: string) {
  return stories.find((s) => s.id === id);
}
export function formatINR(n: number) {
  return "₹" + n.toLocaleString("en-IN");
}
export function progressPct(c: Cause) {
  return Math.min(100, Math.round((c.raised / c.required) * 100));
}
